// Format US phone numbers consistently across the app as 10-digit (XXX) XXX-XXXX.
// Falls back to the raw input if it isn't a 10- or 11-digit number.
//
// Examples:
//   formatPhone("5551234567")        => "(555) 123-4567"
//   formatPhone("(555) 123-4567")    => "(555) 123-4567"
//   formatPhone("15551234567")       => "+1 (555) 123-4567"
//   formatPhone("5551234")           => "5551234"  (too short — left raw)
//   formatPhone("+44 20 7946 0958")  => unchanged (international, non-NANP)

const NUMERIC = /\D+/g;

export function formatPhone(raw) {
  if (!raw) return '';
  const digits = String(raw).replace(NUMERIC, '');
  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  // For any other length (international or partial), return as-is
  return String(raw);
}

// Live-format helper while user types. Trims to 10 digits, masks progressively.
export function formatPhoneInput(raw) {
  if (!raw) return '';
  const digits = String(raw).replace(NUMERIC, '').slice(0, 10);
  if (digits.length === 0) return '';
  if (digits.length <= 3) return `(${digits}`;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}

// Validation — returns true if the value contains a complete 10-digit number
export function isValidPhone(raw) {
  if (!raw) return false;
  const digits = String(raw).replace(NUMERIC, '');
  return digits.length === 10 || (digits.length === 11 && digits.startsWith('1'));
}

// Strip everything but digits for storage (10 max, drops leading 1)
export function normalizePhone(raw) {
  if (!raw) return '';
  let digits = String(raw).replace(NUMERIC, '');
  if (digits.length === 11 && digits.startsWith('1')) digits = digits.slice(1);
  return digits.slice(0, 10);
}
